'use client';

import { Controller, useFormContext } from 'react-hook-form';
import type { FormCheckboxInputProps, FormType } from '../../types/types';

import { Checkbox } from '../../../components/ui';
import { FormField } from '../FormField/FormField';

export const FormCheckboxInput = <T extends FormType>({
	name,
	label,
	helperText,
	optionalText,
	isRequired,
	_formField,
	...rest
}: FormCheckboxInputProps<T>) => {
	const { control, formState } = useFormContext();

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={isRequired}
			{..._formField}
		>
			<Controller
				control={control}
				name={name}
				render={({ field }) => (
					<Checkbox
						checked={field.value}
						disabled={formState.isSubmitting}
						invalid={formState.errors[name] !== undefined}
						onCheckedChange={({ checked }) => field.onChange(checked)}
						{...rest}
					/>
				)}
			/>
		</FormField>
	);
};